
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { Menu } from 'actions/actionTypes';
import * as actions from 'actions/common/menu';

import { callMenuList } from 'network/apis/common/menu';

function* loadMenuRequestSaga() {
    try {
        const response = yield call(callMenuList);

        yield put(actions.loadMenuSuccess(response.data));
    } catch(error) {
        yield put(actions.loadMenuFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([
        takeLatest(Menu.LOAD_MENU_REQUEST, loadMenuRequestSaga),
    ]);
}